
export default function defaultReturnItem() {
    return ({
        units: null, return_reason: null, item_description: null
    })
}